export var VendorInsuranceGrade;
(function (VendorInsuranceGrade) {
    VendorInsuranceGrade["A"] = "A";
    VendorInsuranceGrade["B"] = "B";
    VendorInsuranceGrade["C"] = "C";
    VendorInsuranceGrade["D"] = "D";
    VendorInsuranceGrade["E"] = "E";
})(VendorInsuranceGrade || (VendorInsuranceGrade = {}));
